"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportOrderType = exports.ReportMetricType = exports.ReportFilterOperation = exports.ReportDateHistogramType = exports.ReportAggregationSortType = exports.ReportAggregationType = void 0;
var ReportAggregationType;
(function (ReportAggregationType) {
  ReportAggregationType["TERMS"] = "TERMS";
  ReportAggregationType["HISTOGRAM"] = "HISTOGRAM";
  ReportAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(ReportAggregationType = exports.ReportAggregationType || (exports.ReportAggregationType = {}));
var ReportAggregationSortType;
(function (ReportAggregationSortType) {
  ReportAggregationSortType["COUNT"] = "COUNT";
  ReportAggregationSortType["ALPHA"] = "ALPHA";
  ReportAggregationSortType["METRIC"] = "METRIC";
})(ReportAggregationSortType = exports.ReportAggregationSortType || (exports.ReportAggregationSortType = {}));
var ReportDateHistogramType;
(function (ReportDateHistogramType) {
  ReportDateHistogramType["HOUR"] = "HOUR";
  ReportDateHistogramType["DAY"] = "DAY";
  ReportDateHistogramType["WEEK"] = "WEEK";
  ReportDateHistogramType["MONTH"] = "MONTH";
  ReportDateHistogramType["QUARTER"] = "QUARTER";
  ReportDateHistogramType["YEAR"] = "YEAR";
})(ReportDateHistogramType = exports.ReportDateHistogramType || (exports.ReportDateHistogramType = {}));
var ReportFilterOperation;
(function (ReportFilterOperation) {
  ReportFilterOperation["EQ"] = "EQ";
  ReportFilterOperation["NEQ"] = "NEQ";
  ReportFilterOperation["GT"] = "GT";
  ReportFilterOperation["GTE"] = "GTE";
  ReportFilterOperation["LT"] = "LT";
  ReportFilterOperation["LTE"] = "LTE";
  ReportFilterOperation["IN"] = "IN";
  ReportFilterOperation["NOT_IN"] = "NOT_IN";
  ReportFilterOperation["BETWEEN"] = "BETWEEN";
  ReportFilterOperation["HAS_PROPERTY"] = "HAS_PROPERTY";
  ReportFilterOperation["NOT_HAS_PROPERTY"] = "NOT_HAS_PROPERTY";
  ReportFilterOperation["CONTAINS"] = "CONTAINS";
  ReportFilterOperation["NOT_CONTAINS"] = "NOT_CONTAINS";
})(ReportFilterOperation = exports.ReportFilterOperation || (exports.ReportFilterOperation = {}));
var ReportMetricType;
(function (ReportMetricType) {
  ReportMetricType["DOC_COUNT"] = "DOC_COUNT";
  ReportMetricType["COUNT"] = "COUNT";
  ReportMetricType["SUM"] = "SUM";
  ReportMetricType["AVG"] = "AVG";
  ReportMetricType["MIN"] = "MIN";
  ReportMetricType["MAX"] = "MAX";
  ReportMetricType["MEDIAN"] = "MEDIAN";
  ReportMetricType["DISTINCT_COUNT"] = "DISTINCT_COUNT";
  ReportMetricType["TOP_HITS"] = "TOP_HITS";
})(ReportMetricType = exports.ReportMetricType || (exports.ReportMetricType = {}));
var ReportOrderType;
(function (ReportOrderType) {
  ReportOrderType["ASC"] = "ASC";
  ReportOrderType["DESC"] = "DESC";
})(ReportOrderType = exports.ReportOrderType || (exports.ReportOrderType = {}));